function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_130",
  "data-name": "Group 130",
  transform: "translate(-643.002 -481.998)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Union_2",
  "data-name": "Union 2",
  d: "M11435,8667v-59h110v59Z",
  transform: "translate(-10792 -8126)",
  fill: "#2699fb"
}), /*#__PURE__*/React.createElement("text", {
  id: "Prijs_berekenen",
  "data-name": "Prijs berekenen",
  transform: "translate(698 506)",
  fill: "#f9fcff",
  fontSize: 16,
  fontFamily: "'Avenir LT Std', Arial, sans-serif",
  fontWeight: 800
}, /*#__PURE__*/React.createElement("tspan", {
  x: -15.712,
  y: 0
}, "Prijs"), /*#__PURE__*/React.createElement("tspan", {
  x: -39.856,
  y: 22
}, "berekenen")));

var SvgGet = function SvgGet(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109.998,
    height: 59.002,
    viewBox: "0 0 109.998 59.002",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/get.0d71f2fe.svg";
export { ForwardRef as ReactComponent };